import { Component, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ToastService } from '../../../../../services/toast.service';
import { MaterialExcluido } from '../../../../../types/MaterialExcluido.type';
import { MaterialExcluidoService } from './material-excluido.service';

@Component({
  selector: 'app-material-excluido',
  templateUrl: './material-excluido.component.html',
  styleUrl: './material-excluido.component.css',
  providers: [ConfirmationService]
})
export class MaterialExcluidoComponent {
  @ViewChild('dt') table!: Table;

  registros: MaterialExcluido[] = [];
  loading: boolean = false;
  totalRecords: number = 0;
  quantidadePorPagina: number = 20;

  dialogVisivel: boolean = false;
  registro: MaterialExcluido = {} as MaterialExcluido;
  enviado: boolean = false;

  constructor(
    private service: MaterialExcluidoService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) {}

  onLazyLoad(event: any) {
    this.loading = true;
    const sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    const sortField = event.sortField || 'codigoMaterial';

    this.service
      .getAll(event.first / event.rows, event.rows, sortField, sortDirection)
      .subscribe({
        next: (data) => {
          this.registros = data.content;
          this.totalRecords = data.totalElements;
        },
        error: (error) => {
          this.loading = false;
          this.toastService.erro('Erro', 'Erro ao buscar os registros: ' + (error.error?.message || error.error));
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  recarregar() {
    if (this.table) {
      this.table.first = 0;
      this.onLazyLoad({
        first: 0,
        rows: this.table.rows || 20,
        sortField: this.table.sortField || 'codigoMaterial',
        sortOrder: this.table.sortOrder || 1
      });
    }
  }

  abrirNovo() {
    this.registro = {} as MaterialExcluido;
    this.enviado = false;
    this.dialogVisivel = true;
  }

  abrirEdicao(registro: MaterialExcluido) {
    this.registro = { ...registro };
    this.enviado = false;
    this.dialogVisivel = true;
  }

  fecharDialog() {
    this.dialogVisivel = false;
    this.enviado = false;
    this.registro = {} as MaterialExcluido;
  }

  salvar() {
    this.enviado = true;

    if (!this.registro.codigoMaterial?.trim()) {
      return;
    }

    const body = { codigoMaterial: this.registro.codigoMaterial.trim() };

    if (this.registro.publicId) {
      this.service.put(this.registro.publicId, body).subscribe({
        next: () => {
          this.toastService.sucesso('Atualização', 'Registro atualizado com sucesso.');
          this.fecharDialog();
          this.recarregar();
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao atualizar: ' + (error.error?.message || error.error));
        }
      });
    } else {
      this.service.post(body).subscribe({
        next: () => {
          this.toastService.sucesso('Cadastro', 'Registro cadastrado com sucesso.');
          this.fecharDialog();
          this.recarregar();
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao cadastrar: ' + (error.error?.message || error.error));
        }
      });
    }
  }

  alternarStatus(registro: MaterialExcluido) {
    this.service.alternarStatus(registro.publicId).subscribe({
      next: (atualizado) => {
        registro.ativo = atualizado.ativo;
        this.toastService.sucesso('Status', `Registro ${atualizado.ativo ? 'ativado' : 'desativado'} com sucesso.`);
      },
      error: (error) => {
        registro.ativo = !registro.ativo;
        this.toastService.erro('Erro', 'Erro ao alternar status: ' + (error.error?.message || error.error));
      }
    });
  }

  confirmarExclusao(registro: MaterialExcluido) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir este registro?',
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.service.delete(registro.publicId).subscribe({
          next: () => {
            this.toastService.sucesso('Exclusão', 'Registro excluído com sucesso.');
            this.recarregar();
          },
          error: (error) => {
            this.toastService.erro('Erro', 'Erro ao excluir: ' + (error.error?.message || error.error));
          }
        });
      }
    });
  }
}
